import { SxProps, Theme } from "@mui/material/styles";

const ACCENT_PURPLE = "#7B49C1";
const ACCENT_PURPLE_HOVER = "#6A3FB0";
const ACCENT_PURPLE_LIGHT = "rgba(123, 73, 193, 0.08)";
const ACCENT_PURPLE_BORDER = "rgba(123, 73, 193, 0.2)";

export const dialogPaperStyles = (theme: Theme): SxProps<Theme> => ({
  borderRadius: "18px",
  backgroundColor:
    theme.palette.footer.menuDropdown?.bgColor ||
    theme.palette.background.paper,
  padding: "20px",
});

export const dialogContentStyles = (theme: Theme): SxProps<Theme> => ({
  padding: "20px",
});

export const titleStyles = (theme: Theme): SxProps<Theme> => ({
  fontWeight: "bold",
  marginBottom: "16px",
  color: theme.palette.mode === "dark" ? theme.palette.text.primary : "#111827",
});

export const detailsTextStyles = (theme: Theme): SxProps<Theme> => ({
  fontSize: "16px",
  lineHeight: "1.6",
  color: theme.palette.mode === "dark" ? theme.palette.text.primary : "#374151",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  padding: "24px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(123, 73, 193, 0.12)"
      : ACCENT_PURPLE_LIGHT,
  borderRadius: "10px",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(123, 73, 193, 0.28)"
      : ACCENT_PURPLE_BORDER
  }`,
  marginBottom: "8px",
  "& p": {
    margin: "0 0 12px 0",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& strong, & b": {
    fontWeight: 700,
    color: theme.palette.mode === "dark" ? "#B794F6" : ACCENT_PURPLE,
  },
  "& em, & i": {
    fontStyle: "italic",
  },
});

export const optionsContainerStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  marginTop: "8px",
});

export const optionItemStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  flexDirection: "column",
  padding: "8px 12px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(123, 73, 193, 0.08)"
      : ACCENT_PURPLE_LIGHT,
  borderRadius: "8px",
  border: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(123, 73, 193, 0.2)"
      : ACCENT_PURPLE_BORDER
  }`,
});

export const optionKeyStyles = (theme: Theme): SxProps<Theme> => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.mode === "dark" ? theme.palette.text.primary : "#111827",
  marginBottom: "4px",
});

export const optionValueStyles = (theme: Theme): SxProps<Theme> => ({
  fontSize: "14px",
  color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "#6B7280",
});

export const emptyOptionsTextStyles = (theme: Theme): SxProps<Theme> => ({
  fontSize: "14px",
  color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "#9CA3AF",
  fontStyle: "italic",
});

export const dialogActionsStyles = (theme: Theme): SxProps<Theme> => ({
  padding: "16px 20px",
  gap: "12px",
  justifyContent: "flex-end",
});

export const cancelButtonStyles = (theme: Theme): SxProps<Theme> => ({
  textTransform: "none",
  borderRadius: "6px",
  padding: "8px 16px",
  borderColor: theme.palette.mode === "dark" ? theme.palette.text.secondary : "#E5E7EB",
  color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "#6B7280",
  "&:hover": {
    borderColor: theme.palette.mode === "dark" ? theme.palette.text.primary : "#D1D5DB",
    backgroundColor: "transparent",
    color: theme.palette.mode === "dark" ? theme.palette.text.primary : "#374151",
  },
});

export const okButtonStyles: SxProps<Theme> = {
  textTransform: "none",
  borderRadius: "6px",
  padding: "8px 16px",
  backgroundColor: ACCENT_PURPLE,
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: ACCENT_PURPLE_HOVER,
  },
  "&:disabled": {
    backgroundColor: ACCENT_PURPLE,
    color: "#FFFFFF",
    opacity: 0.5,
  },
};
